export const orderings = [
  {
    description: 'Uswitch rated',
    sortKey: 'RANK_ASC',
    tooltip:
      'Uswitch rated takes into account deals that are proving to be popular with our customers, that are competitive in the market and have a smooth buying process.'
  },
  {
    description: 'Cost (low to high)',
    sortKey: 'COST_ASC'
  },
  {
    description: 'Contract length',
    sortKey: 'CONTRACT_LENGTH_ASC'
  },
  {
    description: 'Speed (high to low)',
    sortKey: 'SPEED_DESC'
  },
  {
    description: 'Speed (low to high)',
    sortKey: 'SPEED_ASC'
  }
]

export const phoneOrderings = [
  {
    description: 'Uswitch rated',
    sortKey: 'RANK_ASC'
  },
  {
    description: 'Calls (low to high)',
    sortKey: 'CALLS_ASC'
  },
  {
    description: 'Calls (high to low)',
    sortKey: 'CALLS_DESC'
  },
  {
    description: 'Contract',
    sortKey: 'CONTRACT_LENGTH_ASC'
  },
  {
    description: 'Cost (low to high)',
    sortKey: 'COST_ASC'
  },
  {
    description: 'Cost (high to low)',
    sortKey: 'COST_DESC'
  }
]
